<template>
  <div class="ja-funnel-view">
    <div class="ja-funnel-view__kpis">
      <kpi-card
        v-for="kpi in data.kpis"
        :key="kpi.title"
        :title="kpi.title"
        :value="kpi.value"
        :icon="kpi.icon"
        :icon-color="kpi.color"
        :highlight="kpi.highlight"
      />
    </div>

    <div class="ja-funnel-view__middle">
      <div class="ja-funnel-view__col">
        <customer-funnel
          :stages="data.funnel"
          :revenue="data.revenueCollected"
        />
      </div>
      <div class="ja-funnel-view__col">
        <conversion-rates-chart :rates="data.conversionRates" />
      </div>
    </div>
  </div>
</template>

<script>
import KpiCard from "./KpiCard.vue";
import CustomerFunnel from "./CustomerFunnel.vue";
import ConversionRatesChart from "./ConversionRatesChart.vue";

export default {
  name: "FunnelView",
  components: {
    KpiCard,
    CustomerFunnel,
    ConversionRatesChart,
  },
  props: {
    data: { type: Object, required: true },
  },
};
</script>

<style scoped lang="scss">
.ja-funnel-view {
  &__kpis {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 1rem;
    margin-bottom: 1.5rem;

    @media (max-width: 1200px) {
      grid-template-columns: repeat(3, 1fr);
    }

    @media (max-width: 768px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 480px) {
      grid-template-columns: 1fr;
    }
  }

  &__middle {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;

    @media (max-width: 992px) {
      grid-template-columns: 1fr;
    }
  }
}
</style>
